exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.map-holder {\n  position: fixed;\n  top: 56px;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n#map {\n  width: 100%;\n  height: 100%;\n}\n.county-detail-modal {\n  position: fixed;\n  bottom: 0;\n  overflow: auto;\n  background-color: #fff;\n  max-height: 0%;\n  bottom: 0;\n  transition: max-height 250ms;\n}\n.county-detail-modal.open {\n  max-height: 50%;\n}\n.county-detail-modal .btn-close {\n  position: fixed;\n  z-index: 99999999;\n  left: 50%;\n  margin-left: -28px;\n}\n.county-detail-content {\n  margin: 18px 2px;\n}\n\n", ""]);

// exports
